import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {Observable, Subscription} from 'rxjs';
import { CacheService } from '../../../../services/sys/cache.service';
import { SettingsService } from '../../../../services/sys/settings.service';

@Injectable()
export class CacheLoadCanActivateGuard   {
    cacheServiceSubscription: Subscription;
    constructor(private cacheService: CacheService,
                private settingsService: SettingsService) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {

        if (!this.cacheService.isCacheLoaded()) {
            return new Observable<boolean> (
                (observer) => {
                    this.cacheService.initialize();
                    this.cacheServiceSubscription = this.cacheService.bundleFileLoadingComplete.subscribe(flag => {
                        observer.next(true);
                        observer.complete();
                    });
                }
            )
        }
        else{
            return new Observable<boolean> ((observer) => {
                observer.next(true);
                observer.complete();
            });

        }
    }

}